// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"74":"About","275":"Room","337":"Contact","395":"OpenHotel","527":"Site","841":"Events"}[chunkId] || chunkId) + "." + {"32":"9a281fd3","74":"37090ce5","275":"493d810a","337":"254f7901","395":"f4336d21","404":"3f531df8","527":"0770f86a","841":"f446507e","877":"dfbb1431"}[chunkId] + ".js";
};